import { c as _c } from "react/compiler-runtime";
import { Corner, Root, type ScrollAreaProps, Scrollbar, Thumb, Viewport } from '@radix-ui/react-scroll-area';
import type { ReactNode, RefObject, UIEventHandler } from 'react';
import { cn } from '@/app/utils/cn';
interface CustomScrollProps {
  id: string;
  type: ScrollAreaProps['type'];
  orientation: 'horizontal' | 'vertical';
  children: ReactNode;
  containerClassName?: string;
  scrollRef?: RefObject<HTMLDivElement | null>;
  contentClassName?: string;
  scrollbarClassName?: string;
  thumbClassName?: string;
  onScroll?: UIEventHandler<HTMLDivElement>;
}
export const CustomScroll = t0 => {
  const $ = _c(30);
  const {
    id,
    type: t1,
    orientation,
    children,
    containerClassName,
    scrollRef,
    contentClassName,
    scrollbarClassName,
    thumbClassName,
    onScroll
  } = t0;
  const type = t1 === undefined ? "auto" : t1;
  let t2;
  if ($[0] !== containerClassName) {
    t2 = cn("group size-full overflow-hidden", containerClassName);
    $[0] = containerClassName;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== contentClassName) {
    t3 = cn("size-full", contentClassName);
    $[2] = contentClassName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== onScroll || $[6] !== scrollRef || $[7] !== t3) {
    t4 = <Viewport ref={scrollRef} className={t3} onScroll={onScroll}>{children}</Viewport>;
    $[4] = children;
    $[5] = onScroll;
    $[6] = scrollRef;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = orientation === "horizontal";
  const t6 = orientation === "vertical";
  let t7;
  if ($[9] !== scrollbarClassName || $[10] !== t5 || $[11] !== t6) {
    t7 = cn("flex h-2 touch-none rounded-md bg-gray-200 select-none", {
      "data-[orientation=horizontal]:flex-col": t5,
      "data-[orientation=vertical]:flex-row": t6
    }, scrollbarClassName);
    $[9] = scrollbarClassName;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = orientation === "vertical";
  const t9 = orientation === "horizontal";
  let t10;
  if ($[13] !== t8 || $[14] !== t9 || $[15] !== thumbClassName) {
    t10 = cn("transition-bg relative flex-auto rounded-md bg-gray-400 will-change-transform group-hover:bg-gray-700 hover:bg-gray-700", "before:center-x before:center-y before:absolute before:size-full before:min-h-10 before:min-w-10", {
      "hover:cursor-ns-resize": t8,
      "hover:cursor-ew-resize": t9
    }, thumbClassName);
    $[13] = t8;
    $[14] = t9;
    $[15] = thumbClassName;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <Thumb className={t10} />;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== orientation || $[20] !== t11 || $[21] !== t7) {
    t12 = <Scrollbar className={t7} orientation={orientation}>{t11}</Scrollbar>;
    $[19] = orientation;
    $[20] = t11;
    $[21] = t7;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Corner />;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== id || $[25] !== t12 || $[26] !== t2 || $[27] !== t4 || $[28] !== type) {
    t14 = <Root className={t2} type={type} role="scrollbar" aria-controls={id}>{t4}{t12}{t13}</Root>;
    $[24] = id;
    $[25] = t12;
    $[26] = t2;
    $[27] = t4;
    $[28] = type;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};